<template>
    <div class="styled-input" 
      :class="`${error ? 'error-present': '' } ${hasEditPermission ? '': 'disabled'} ${pendingChanges ? 'pending-changes-container' : ''} ${noMargin ? 'no-margin' : ''}`">
      <label v-if="label" class='light_label' :class="{focused: focused || inputValue != undefined || placeholder || type == 'date'}" :for="inputId">{{ label }}</label>
      <img v-if="icon"
        src="@/assets/search.svg"
        class="input-icon">
      <input v-if="type !== 'options'"
        :type="type"
        :class="`light light_label ${value ? 'hasValue' : ''} ${icon ? 'has-icon' : ''}`"
        :id="inputId"
        :disabled="!hasEditPermission"
        v-model="inputValue"
        :placeholder="placeholder"
        @focus="this.focused = true"
        @blur="this.focused = false"
        @input="emitInputEvent"
        ref="inputComponent"
      />
      <select v-else
        class="select-elem light"
        :id="inputId"
        :disabled="!hasEditPermission"
        v-model="inputValue"
        @change="emitInputEvent">
        <option  v-for="option in options" :value="option.value">{{ option.text }}</option>
      </select>
      <div v-if="error" class="error">{{ error }}</div>
      <img v-if="initialType == 'password' && !canSee"
        src="@/assets/password-look.svg"
        class="password-icon"
        @click="changeTypeOfInput"
      >
      <img v-else-if="initialType == 'password' && canSee"
        src="@/assets/password-hide.svg"
        class="password-icon"
        @click="changeTypeOfInput"
      >
      <div v-if="pendingChanges" class="pending-changes">
        <div title="Pending changes awaiting approval">
          <img src="@/assets/info.svg" class="pending-icon">
        </div>
      </div>


    </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Utils from '@/utils';
  export default {
    
    data() {
      return {
        focused: false,
        inputValue: '',
        initialType: '',
        canSee: false,
      }
    },
    name: 'Input',

    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: false,
      },
      light_label: {
        type: String,
      },  
      type: {
        type: String,
        default: 'text',
      },
      placeholder: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number],
        default: '',
      },
      theme: {
        type: String,
        default: 'dark',
      },
      icon: {
        type: String,
        default: '',
      },
      key_ref: {
        type: String,
        default: '',
      },
      max: {
        type: Number,
        default : null,
      },
      min: {
        type: String,
        default : null,
      },
      max_length: {
        type: Number,
        default : null,
      },
      min_length: {
        type: Number,
        default : null,
      },
      options: {
        type: Array,
        default: () => [],
      },
      error: {
        type: String,
        default : null,
      },
      kyc_validate: {
        type: Boolean,
        default: false,
      },
      pendingChanges: {
        type: Boolean,
        default: false,
      },
      noMargin: {
        type: Boolean,
        default: false,
      }
    },
    mounted() {
      this.initialType = this.type;
      if (this.type == 'date' && this.value) {
        this.inputValue = this.value.split('T')[0];
      } else {
        this.inputValue = this.value;
      }
    },
    methods: {
      ...mapActions(['addNotification']),
      changeTypeOfInput(){
        this.canSee = !this.canSee;
        const input = this.$refs.inputComponent;

        if (this.canSee) {
          input.setAttribute('type', 'text');
        } else {
          input.setAttribute('type', 'password');
        }

      }
    },
    computed: {
      ...mapState(['validationOn', 'user', 'accessToken']),
      inputId() {
        return 'input-' + Math.random().toString(36).substr(2, 10);
      },
      hasEditPermission() {

        if (!this.user && !this.accessToken) {
          return true;
        }
        return !this.disabled;
      },
      emitInputEvent() {
        // if (this.validationOn) {
        //   Utils.validate
        // }
        let calculated_value = this.inputValue;
        if (this.type == 'number' && this.inputValue) {
          if (this.max && this.inputValue > this.max) {
            calculated_value = +this.max;
            this.inputValue = calculated_value;
          }
          if (this.min && this.inputValue < this.min) {
            calculated_value = +this.min;
            this.inputValue = calculated_value;
          }
        }
        if (this.max_length && this.inputValue.toString().length > this.max_length) {
          this.addNotification({text: 'Input too long', type: 'error'})
        }
        this.$emit('input', calculated_value);
        this.$emit('inputChange', [this.key_ref, calculated_value]);
      }
    },
    watch: {
      value(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        } 
        if (newValue && this.type == 'date') {
          this.inputValue = newValue.split('T')[0];
          return
        }
        if (newValue != oldValue) {
          this.inputValue = newValue;
        }
      },
    },
  };
  </script>
  
  <style scoped lang='scss'>
  .styled-input {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    position: relative;
    &.no-margin {
      margin-bottom: 0;
    }
  }
  .has-icon {
    padding-left: 40px;
  }
  .disabled {
    opacity: 0.7;
  }
  .password-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .pending-changes-container {
    input, select {
      border: 1px solid var(--primary-color);
    }
  }
  .pending-changes {
    position: absolute;
    right: -20px;
    top: 13px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    img {
      width: 18px;
      height: 18px;
    }
  }

  label {
    position: absolute;
    pointer-events: none;
    top: 8px;
    left: 10px;
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
    font-weight: lighter;
    color: rgb(116 119 127);
    text-align: left;
    transition: all 0.3s;
    z-index: 2;
    &.focused {
      top: -5px;
      padding: 0 4px;
      background: white;
      left: 7px;
      font-size: 10px;
      color: #3D5873;
    }
  }
  
  input, select {
    background: unset;
    color: black;
    caret-color: black;
    outline: none;
    caret-color: #2b263a;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    border-radius: 5px;
    transition: padding 0.3s;
    border: 1px solid var(--border-color);
    &.select-elem {
      width: 100%;
    }
    &:focus {
      padding-top: 12px;
      padding-bottom: 8px;
      border: 1px solid var(--primary-color);
    }
    &.hasValue {
      padding-top: 12px;
      padding-bottom: 8px;
    }
  }
 
  
  
  .error-present {
    input, select {
      border-color: red;
      border-width: 1.5px;
    }
  }
  .light_label {
    font-size: 13px;
    margin-bottom: 0;
  }
  .error {
    color: red;
    text-align: left;
    padding-left: 10px;
    font-size: 10px;
  }
  input[type="checkbox"] {
    margin-right: auto;
  }
  .input-icon {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
  }
  </style>